import React, { useState, useEffect, useRef, useContext } from "react";
import ReactDOM from "react-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./../../../assets/css/mentor/mentordashboard/StudentReport.css";
import MyMasterLayout from "./../../../layouts/Mentor/MyMasterlayout";
import AppContext from "./../../../context/Appcontext";

// ── Portal ──
const Portal = ({ children }) => {
  const el = useRef(document.createElement("div"));
  useEffect(() => {
    const node = el.current;
    node.style.cssText =
      "position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;pointer-events:all;";
    document.body.appendChild(node);
    document.body.style.overflow = "hidden";
    return () => {
      document.body.removeChild(node);
      document.body.style.overflow = "";
    };
  }, []);
  return ReactDOM.createPortal(children, el.current);
};

const StudentReport = ({ students = [] }) => {
  const { regExpChecker } = useContext(AppContext); // ✅ regExpChecker lo

  const [activeTab, setActiveTab] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [reportedList, setReportedList] = useState([]);
  const [report, setReport] = useState({
    category: "",
    reason: "",
    description: "",
    severity: "medium",
  });

  // ✅ Ek errors state
  const [errors, setErrors] = useState({});

  // ✅ Validation function
  const handleValidation = (field, value) => {
    const error = regExpChecker(field, value);
    setErrors((prev) => ({ ...prev, [field]: error }));
  };

  const defaultStudents = [
    {
      id: 1,
      studentName: "Sarah Ahmed",
      studentImage: "https://i.pravatar.cc/150?img=1",
      areaOfHelp: "Web Development",
      status: "ACTIVE",
    },
    {
      id: 2,
      studentName: "Ali Hassan",
      studentImage: "https://i.pravatar.cc/150?img=2",
      areaOfHelp: "React & Node.js",
      status: "ACTIVE",
    },
    {
      id: 3,
      studentName: "Fatima Khan",
      studentImage: "https://i.pravatar.cc/150?img=3",
      areaOfHelp: "Python & Data Science",
      status: "ACTIVE",
    },
    {
      id: 4,
      studentName: "Usman Raza",
      studentImage: "https://i.pravatar.cc/150?img=4",
      areaOfHelp: "Mobile Development",
      status: "ACTIVE",
    },
  ];

  const displayStudents = students.length > 0 ? students : defaultStudents;

  const categories = [
    { value: "inappropriate_behavior", label: "Inappropriate Behavior" },
    { value: "harassment", label: "Harassment or Bullying" },
    { value: "not_responsive", label: "Not Responsive" },
    { value: "missed_sessions", label: "Repeatedly Missed Sessions" },
    { value: "disrespectful", label: "Disrespectful Conduct" },
    { value: "plagiarism", label: "Academic Dishonesty / Plagiarism" },
    { value: "payment_issue", label: "Payment Issue" },
    { value: "other", label: "Other Issue" },
  ];

  const isReported = (id) => reportedList.some((r) => r.id === id);

  // ✅ isValid mein errors bhi check karo
  const isValid =
    report.category &&
    report.reason.trim() &&
    report.description.trim() &&
    !errors.reason &&
    !errors.description;

  const openModal = (student) => {
    setSelectedStudent(student);
    setReport({
      category: "",
      reason: "",
      description: "",
      severity: "medium",
    });
    setErrors({}); // ✅ modal open hone pe errors reset
    setSubmitted(false);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
    setSubmitted(false);
    setErrors({}); // ✅ close pe bhi reset
  };

  const handleSubmit = () => {
    if (!isValid) return;
    const entry = {
      ...selectedStudent,
      reportId: Date.now(),
      reportedAt: new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
      reportCategory:
        categories.find((c) => c.value === report.category)?.label ||
        report.category,
      reportReason: report.reason,
      reportDescription: report.description,
      reportSeverity: report.severity,
    };
    setReportedList((prev) => {
      const exists = prev.find((r) => r.id === selectedStudent.id);
      return exists
        ? prev.map((r) => (r.id === selectedStudent.id ? entry : r))
        : [...prev, entry];
    });
    setSubmitted(true);
  };

  return (
    <MyMasterLayout>
      <>
        <div className="ms-card">
          {/* ── TAB BAR ── */}
          <div className="ms-tab-bar">
            <div className="ms-tabs">
              <button
                className={`ms-tab-btn ${activeTab === "all" ? "ms-tab-active" : ""}`}
                onClick={() => setActiveTab("all")}
              >
                <i className="bi bi-people-fill"></i>
                All Students
                <span
                  className={`ms-tab-count ${activeTab === "all" ? "ms-tab-count-active" : ""}`}
                >
                  {displayStudents.length}
                </span>
              </button>
              <button
                className={`ms-tab-btn ${activeTab === "reported" ? "ms-tab-active" : ""}`}
                onClick={() => setActiveTab("reported")}
              >
                <i className="bi bi-flag-fill"></i>
                Reported Students
                <span
                  className={`ms-tab-count ${activeTab === "reported" ? "ms-tab-count-active" : ""}`}
                >
                  {reportedList.length}
                </span>
              </button>
            </div>
          </div>

          {/* TAB 1 — ALL STUDENTS */}
          {activeTab === "all" &&
            (displayStudents.length === 0 ? (
              <div className="empty-state">
                <i className="bi bi-people empty-icon"></i>
                <p className="empty-title">No students yet</p>
                <p className="empty-subtitle">
                  Accept mentorship requests to start mentoring students.
                </p>
              </div>
            ) : (
              <div className="ms-table-wrap">
                <table className="ms-table">
                  <thead>
                    <tr className="ms-thead-dark">
                      <th className="ms-th ms-th-left">Student</th>
                      <th className="ms-th ms-th-left">Area of Interest</th>
                      <th className="ms-th ms-th-center">Status</th>
                      <th className="ms-th ms-th-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayStudents.map((s, idx) => (
                      <tr
                        key={s.id}
                        className={`ms-tr ${idx % 2 === 0 ? "ms-tr-even" : "ms-tr-odd"}`}
                      >
                        <td className="ms-td">
                          <div className="ms-student-cell">
                            <div className="ms-avatar-wrap">
                              <img
                                src={
                                  s.studentImage || "https://i.pravatar.cc/150"
                                }
                                alt={s.studentName}
                                className="ms-avatar"
                              />
                              {isReported(s.id) && (
                                <div className="ms-reported-dot">
                                  <i className="bi bi-flag-fill ms-reported-dot-icon"></i>
                                </div>
                              )}
                            </div>
                            <div>
                              <div className="ms-student-name">
                                {s.studentName}
                              </div>
                              <div className="ms-student-id">ID #{s.id}</div>
                            </div>
                          </div>
                        </td>
                        <td className="ms-td">
                          <span className="badge badge-info">
                            {s.areaOfHelp || "Not Specified"}
                          </span>
                        </td>
                        <td className="ms-td ms-td-center">
                          {isReported(s.id) ? (
                            <span className="ms-status-reported">
                              <i className="bi bi-flag-fill ms-status-icon"></i>{" "}
                              Reported
                            </span>
                          ) : (
                            <span className="badge badge-accepted badge-status">
                              <i className="bi bi-check-circle-fill"></i>
                              {s.status || "ACTIVE"}
                            </span>
                          )}
                        </td>
                        <td className="ms-td ms-td-center">
                          <button
                            className={`mys-btn-report ${isReported(s.id) ? "mys-btn-re-report" : ""}`}
                            onClick={() => openModal(s)}
                          >
                            <i className="bi bi-flag-fill"></i>
                            {isReported(s.id) ? "Re-report" : "Report"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}

          {/* TAB 2 — REPORTED STUDENTS */}
          {activeTab === "reported" &&
            (reportedList.length === 0 ? (
              <div className="empty-state">
                <i className="bi bi-shield-check ms-shield-icon"></i>
                <p className="empty-title">No Reported Students</p>
                <p className="empty-subtitle">
                  All students are in good standing. No reports filed yet.
                </p>
              </div>
            ) : (
              <div>
                <div className="ms-table-wrap">
                  <table className="ms-table">
                    <thead>
                      <tr className="ms-thead-red">
                        <th className="ms-th ms-th-left">Student</th>
                        <th className="ms-th ms-th-left">Category</th>
                        <th className="ms-th ms-th-left">Reason</th>
                        <th className="ms-th ms-th-center">Severity</th>
                        <th className="ms-th ms-th-center">Reported On</th>
                        <th className="ms-th ms-th-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportedList.map((r, idx) => (
                        <tr
                          key={r.reportId}
                          className={`ms-reported-row ${idx % 2 === 0 ? "ms-tr-even" : "ms-tr-odd"}`}
                        >
                          <td className="ms-td">
                            <div className="ms-student-cell">
                              <img
                                src={
                                  r.studentImage || "https://i.pravatar.cc/150"
                                }
                                alt={r.studentName}
                                className="ms-avatar ms-avatar-sm"
                              />
                              <div>
                                <div className="ms-student-name">
                                  {r.studentName}
                                </div>
                                <div className="ms-student-id">
                                  {r.areaOfHelp}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="ms-td">
                            <span className="ms-category-badge">
                              {r.reportCategory}
                            </span>
                          </td>
                          <td className="ms-td ms-td-reason">
                            <p
                              className="ms-reason-text"
                              title={r.reportReason}
                            >
                              {r.reportReason}
                            </p>
                          </td>
                          <td className="ms-td ms-td-center">
                            <span
                              className={`ms-sev-badge ms-sev-${r.reportSeverity}`}
                            >
                              {r.reportSeverity}
                            </span>
                          </td>
                          <td className="ms-td ms-td-center">
                            <span className="ms-date-text">{r.reportedAt}</span>
                          </td>
                          <td className="ms-td ms-td-center">
                            <button
                              className="ms-update-btn"
                              onClick={() => openModal(r)}
                            >
                              <i className="bi bi-arrow-repeat"></i> Update
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="ms-summary-footer">
                  <span className="ms-summary-total">
                    <i className="bi bi-flag-fill"></i> Total Reports:{" "}
                    {reportedList.length}
                  </span>
                  {["high", "medium", "low"].map((sev) => {
                    const cnt = reportedList.filter(
                      (r) => r.reportSeverity === sev,
                    ).length;
                    if (!cnt) return null;
                    return (
                      <span
                        key={sev}
                        className={`ms-summary-sev ms-summary-${sev}`}
                      >
                        {sev.charAt(0).toUpperCase() + sev.slice(1)}: {cnt}
                      </span>
                    );
                  })}
                </div>
              </div>
            ))}
        </div>

        {/* ════ REPORT MODAL ════ */}
        {showModal && selectedStudent && (
          <Portal>
            <div className="ms-modal-overlay" onClick={closeModal}>
              <div
                className="mys-modal-container ms-modal-animate"
                onClick={(e) => e.stopPropagation()}
              >
                {submitted ? (
                  <div className="ms-success-body">
                    <div className="ms-success-anim">
                      <div className="ms-success-circle">✓</div>
                    </div>
                    <h2 className="ms-success-title">Report Submitted!</h2>
                    <p className="ms-success-sub">
                      Report about{" "}
                      <strong>{selectedStudent.studentName}</strong> has been
                      sent to admin.
                    </p>
                    <p className="ms-success-hint">
                      You can view this report anytime in the{" "}
                      <strong>"Reported Students"</strong> tab.
                    </p>
                    <button
                      className="mys-btn-submit ms-success-btn"
                      onClick={closeModal}
                    >
                      Done
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="mys-modal-header ms-modal-header-red">
                      <div className="mys-modal-title-section">
                        <div className="ms-modal-icon-box">🚩</div>
                        <div>
                          <p className="mys-modal-title ms-white-text">
                            Report Student to Admin
                          </p>
                          <p className="mys-modal-subtitle ms-muted-text">
                            This report will be kept confidential
                          </p>
                        </div>
                      </div>
                      <button
                        className="mys-modal-close ms-close-white"
                        onClick={closeModal}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>

                    <div className="mys-modal-body">
                      <div className="mys-student-info-card">
                        <img
                          src={
                            selectedStudent.studentImage ||
                            "https://i.pravatar.cc/150"
                          }
                          alt={selectedStudent.studentName}
                          className="mys-student-avatar-large"
                        />
                        <div className="mys-student-details">
                          <p className="mys-student-name-large">
                            {selectedStudent.studentName}
                          </p>
                          <p className="mys-student-interest">
                            <i className="bi bi-bookmark-fill"></i>
                            {selectedStudent.areaOfHelp || "Not Specified"}
                          </p>
                        </div>
                        <span className="badge badge-accepted badge-status">
                          <i className="bi bi-check-circle-fill"></i>
                          {selectedStudent.status || "ACTIVE"}
                        </span>
                      </div>

                      {/* Category */}
                      <div className="mys-form-group">
                        <label className="mys-label">
                          Report Category{" "}
                          <span className="mys-required">*</span>
                        </label>
                        <select
                          className="mys-select"
                          value={report.category}
                          onChange={(e) =>
                            setReport((r) => ({
                              ...r,
                              category: e.target.value,
                            }))
                          }
                        >
                          <option value="">-- Select a category --</option>
                          {categories.map((cat) => (
                            <option key={cat.value} value={cat.value}>
                              {cat.label}
                            </option>
                          ))}
                        </select>
                        {/* ✅ Category error */}
                        {!report.category && errors.category && (
                          <small className="text-danger">
                            {errors.category}
                          </small>
                        )}
                      </div>

                      {/* Reason */}
                      <div className="mys-form-group">
                        <label className="mys-label">
                          Brief Reason <span className="mys-required">*</span>
                        </label>
                        <input
                          type="text"
                          className="mys-input"
                          placeholder="e.g. Missed 3 consecutive sessions without notice"
                          value={report.reason}
                          onChange={(e) => {
                            setReport((r) => ({
                              ...r,
                              reason: e.target.value,
                            }));
                            handleValidation("reason", e.target.value); // ✅
                          }}
                        />
                        {/* ✅ Reason error */}
                        {errors.reason && (
                          <small className="text-danger">{errors.reason}</small>
                        )}
                      </div>

                      {/* Description */}
                      <div className="mys-form-group">
                        <label className="mys-label">
                          Detailed Description{" "}
                          <span className="mys-required">*</span>
                        </label>
                        <textarea
                          className="mys-textarea"
                          rows={5}
                          placeholder="Provide detailed information about the issue..."
                          value={report.description}
                          onChange={(e) => {
                            setReport((r) => ({
                              ...r,
                              description: e.target.value,
                            }));
                            handleValidation("description", e.target.value); // ✅
                          }}
                        />
                        {/* ✅ Description error */}
                        {errors.description && (
                          <small className="text-danger">
                            {errors.description}
                          </small>
                        )}
                        <p className="mys-helper-text">
                          Be specific and objective. Include dates, times, and
                          factual details.
                        </p>
                      </div>

                      {/* Severity */}
                      <div className="mys-form-group">
                        <label className="mys-label">Severity Level</label>
                        <div className="mys-severity-options">
                          {["low", "medium", "high"].map((sev) => (
                            <label key={sev} className="mys-severity-option">
                              <input
                                type="radio"
                                name="severity"
                                value={sev}
                                checked={report.severity === sev}
                                onChange={(e) =>
                                  setReport((r) => ({
                                    ...r,
                                    severity: e.target.value,
                                  }))
                                }
                              />
                              <span
                                className={`mys-severity-badge mys-severity-${sev}`}
                              >
                                <i
                                  className={`bi ${sev === "low" ? "bi-info-circle-fill" : sev === "medium" ? "bi-exclamation-triangle-fill" : "bi-exclamation-octagon-fill"}`}
                                ></i>
                                {sev.charAt(0).toUpperCase() + sev.slice(1)}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className="mys-notice-box">
                        <i className="bi bi-shield-check-fill"></i>
                        <div>
                          <p className="mys-notice-title">
                            Confidential Report
                          </p>
                          <p className="mys-notice-text">
                            This report will be sent directly to the admin team.
                            Your identity will remain confidential throughout
                            the review process.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mys-modal-footer">
                      <button className="mys-btn-cancel" onClick={closeModal}>
                        Cancel
                      </button>
                      <button
                        className="mys-btn-submit"
                        onClick={handleSubmit}
                        disabled={!isValid}
                        style={{
                          opacity: isValid ? 1 : 0.5,
                          cursor: isValid ? "pointer" : "not-allowed",
                        }}
                      >
                        <i className="bi bi-send-fill"></i> Submit Report
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Portal>
        )}
      </>
    </MyMasterLayout>
  );
};

export default StudentReport;
